import IntermodalRouteWithDetailsType from "@Intermodal/types/IntermodalRouteWithDetails.type";
import RouteWithAddedPropsAndPricesType from "@Route/types/RouteWithAddedPropsAndPrices.type";
import SuggestedRouteType from "@Route/types/SuggestedRoute.type";
import DiscountBadge from "@Route/features/statusBadges/features/rightStatusBadges/components/DiscountBadge";
import useShowRightStatusBadges
    from "@Route/features/statusBadges/features/rightStatusBadges/hooks/useShowRightStatusBadges";

interface RightRouteStatusBadgesProps {
    route: IntermodalRouteWithDetailsType | RouteWithAddedPropsAndPricesType | SuggestedRouteType,
}

function RightRouteStatusBadges({route}: RightRouteStatusBadgesProps) {
    const showBadge = useShowRightStatusBadges(route)
    const {
        prices: {
            activeDiscount,
        },
    } = route

    return (
        <div className="route-status-badges__right">
            {showBadge.showDiscountsBadge && (
                <DiscountBadge
                    isActive={activeDiscount?.isActive}
                    discountAmount={activeDiscount?.discountPercentage}
                />
            )}
        </div>
    )
}

export default RightRouteStatusBadges